import React from "react";
import "../Styles/ReviewSection.css";
import { REVIEWS_DATA } from "../utils/constants";

const ReviewCard=({content,tag,variant="item-1"})=>(
  <div className={variant}>
      <p className={`${variant}-content`}>{content}</p>
      <p className={`${variant}-tag`}>{tag}</p>
    </div>
)

const ReviewSection = () => {
  
  return (
    <div className="review-container-with-head">
      <h2 className="review-heading">What Our Students Are Saying!</h2>
      <div className="reviews-container">
      {REVIEWS_DATA.map((item,index)=>(
        <React.Fragment key={index}>
        <ReviewCard content={item[0].content} tag={item[0].tag}/>
        <div className="item-2-container">
          <ReviewCard content={item[1].content} tag={item[1].tag} variant="item-2"/>
          <ReviewCard content={item[2].content} tag={item[2].tag} variant="item-2"/>
        </div>
        </React.Fragment>
      ))}
      </div>
    </div>
  );
};

export default ReviewSection;



// import React from "react";
// import "../Styles/ReviewSection.css";
// import { REVIEWS_DATA } from "../utils/constants";

// const ReviewSection = () => {

//   const arr=[];

//   REVIEWS_DATA.map((item)=>{
//     arr.push(<div className="item-1">
      
//       <p className="item-1-content">{item[0].content}</p>
//       <p className="item-1-tag">{item[0].tag}</p>
//     </div>)
//     arr.push(<div className="item-2-container">
//       <div id="item-2">
//         <p id="item-2-content">{item[1].content}</p>
//         <p id="item-2-tag">{item[1].tag}</p>
//       </div>
//       <div id="item-2">
//         <p id="item-2-content">{item[2].content}</p>
//         <p id="item-2-tag">{item[2].tag}</p>
//       </div>
//     </div>)
        
//   })

//   return (
//     <div className="reviews-container">
//      {arr.map((item)=>{
//       return(item)
//      })}
        

//     </div>
//   );
// };

// export default ReviewSection;
